(() => {
  const initialiseHeroTypewriter = () => {
    const heading = document.querySelector('.hs-hero .hs-h1');
    if (!heading || heading.dataset.typewriterReady === 'true') return;

    heading.dataset.typewriterReady = 'true';
    heading.setAttribute('aria-label', heading.textContent.replace(/\s+/g, ' ').trim());

    const textNodes = [];
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    let characterIndex = 0;
    textNodes.forEach((textNode) => {
      const fragment = document.createDocumentFragment();
      textNode.textContent.trim().split(/\s+/).filter(Boolean).forEach((word, wordIndex) => {
        if (wordIndex > 0) fragment.appendChild(document.createTextNode(' '));
        const wordElement = document.createElement('span');
        wordElement.className = 'hs-typewriter__word';
        wordElement.setAttribute('aria-hidden', 'true');
        Array.from(word).forEach((character) => {
          const characterElement = document.createElement('span');
          characterElement.className = 'hs-typewriter__char';
          characterElement.style.setProperty('--hs-character-delay', `${characterIndex * 40}ms`);
          characterElement.textContent = character;
          wordElement.appendChild(characterElement);
          characterIndex += 1;
        });
        fragment.appendChild(wordElement);
      });
      textNode.replaceWith(fragment);
    });

    heading.classList.add('hs-typewriter');

  };

  const initialiseScrollReveals = (root = document) => {
    if (!document.querySelector('.hs-hero')) return;

    const selector = [
      '.hs-cat__top',
      '.hs-grid > *',
      '.hs-featured__head',
      '.hs-prodgrid > *',
      '.hs-featured__footer',
      '.hs-inner > *',
      '.title-wrapper',
      '.product-grid > .grid__item',
      '.collection-list > .grid__item',
      '.banner__box'
    ].join(',');
    const heroSection = document.querySelector('.hs-hero')?.closest('.shopify-section');
    const targets = Array.from(root.querySelectorAll(selector)).filter((element) =>
      !element.closest('.hs-hero') && !element.dataset.scrollRevealReady
    );

    root.querySelectorAll('main .shopify-section').forEach((section) => {
      if (section === heroSection || section.querySelector(selector)) return;
      const fallbackTarget = section.firstElementChild;
      if (fallbackTarget && !fallbackTarget.dataset.scrollRevealReady) targets.push(fallbackTarget);
    });

    targets.forEach((element, index) => {
      element.dataset.scrollRevealReady = 'true';
      element.classList.add('hs-scroll-reveal');
      element.style.setProperty('--hs-reveal-delay', `${(index % 4) * 45}ms`);
    });
    document.documentElement.classList.add('hs-scroll-reveal-ready');

    if (!('IntersectionObserver' in window)) {
      targets.forEach((element) => element.classList.add('hs-scroll-reveal--visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hs-scroll-reveal--visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    targets.forEach((element) => observer.observe(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseHeroTypewriter, { once: true });
  } else {
    initialiseHeroTypewriter();
  }

  initialiseScrollReveals();
  document.addEventListener('shopify:section:load', (event) => {
    initialiseHeroTypewriter();
    initialiseScrollReveals(event.target);
  });
})();
